"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.CALENDAR_VIEW, (table)=>{
        table.string('fk_view_id', 20).primary();
        table.string('base_id', 20);
        table.string('source_id', 128);
        table.string('title');
        table.string('fk_cover_image_col_id', 20);
        table.text('meta');
        table.dateTime('created_at');
        table.dateTime('updated_at');
    });
    await knex.schema.createTable(_globals.MetaTable.CALENDAR_VIEW_COLUMNS, (table)=>{
        table.string('id', 20).primary().notNullable();
        table.string('base_id', 20);
        table.string('source_id', 128);
        table.string('fk_view_id', 20);
        table.string('fk_column_id', 20);
        table.boolean('show');
        table.boolean('bold');
        table.boolean('underline');
        table.boolean('italic');
        table.float('order');
        table.timestamps(true, true);
    });
    await knex.schema.createTable(_globals.MetaTable.CALENDAR_VIEW_RANGE, (table)=>{
        table.string('id', 20).primary().notNullable();
        table.string('fk_view_id', 20);
        table.string('fk_to_column_id', 20);
        table.string('label', 40);
        table.string('fk_from_column_id', 20);
        table.timestamps(true, true);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.CALENDAR_VIEW);
    await knex.schema.dropTable(_globals.MetaTable.CALENDAR_VIEW_COLUMNS);
    await knex.schema.dropTable(_globals.MetaTable.CALENDAR_VIEW_RANGE);
};
